export default __webpack_public_path__ + "static/media/right-arrow.7b2b1174.svg";